import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AlterarSenhaGuard implements CanActivate {
  private usuarioLogado = false;
  constructor(
    public authentication: AuthenticationService,
    public router: Router
  ) {
    this.authentication.authNavStatus$.subscribe({
      next: (status) => {
        this.usuarioLogado = status;
      }
    });
  }

  canActivate(): boolean {
    if (this.usuarioLogado) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}
